import React from 'react';
import store from 'store2';
import PropTypes from 'prop-types';
import { Grid, Header, Icon, Image } from 'semantic-ui-react';
import { connect } from 'react-redux';
import Login from '../../components/Login';
import Signup from '../Signup';
import Footer from '../../components/Mainfooter';
import { Images } from '../../style';
import { Link, withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { getQueryParams } from '../../helpers/commonHelper';


const Home = withRouter(({ location, user, dispatch }) => {
  let shopifyAccessToken = '';
  let shopifyStore = '';
  if (location.search) {
    const res = getQueryParams(location.search);
    if(res) {
      if(res.accessToken) {
        store('authToken', res.accessToken);
        window.history.replaceState({}, document.title, "/");
      }
      if(res.shopifyToken) {
        shopifyAccessToken = res.shopifyToken;
        shopifyStore = res.store;
        if(!user) {
          dispatch(push(`signup/free/?shopifyToken=${shopifyAccessToken}&store=${shopifyStore}`));
        }
      }
    }
  }
  return (
    <div className="height login-bg">
    <Grid className="full-height">
      <Grid.Row divided centered  >
        <Grid.Column mobile={14} tablet={7} computer={7}>
          <a href="https://www.videopeel.com/" >
            <Image className="logo" src={Images.logo} centered/>
          </a>
          <Login
            location = {location}
            shopifyToken={shopifyAccessToken}
            shopifyStore={shopifyStore}/>
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <Footer/>
    </div>
  );
});

Home.propTypes = {
  user: PropTypes.object,
};

Home.defaultProps = {
  user: null,
};

export default connect(state => ({
  user: state.get('auth').get('user'),
}))(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js